import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import Button from "components/Button"
import ClpTable from "components/ClpTable"
import TableButton from "components/ClpTable/components/actions/TableButton/TableButton"
import { TableButtonTypeEnum } from "components/ClpTable/components/actions/TableButton/tableButtonProps.interface"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useContext, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import { StyledTableContainer } from "shared/styled/Global"

const EditCustomerCompanies = () => {
  const routerHistory = useHistory()
  const { t } = useTranslation()
  const [customerResult, getCustomer] = useApiGet()
  const loadingContext = useContext(GlobalLoaderContext)

  useEffect(() => {
    getCustomer(apiEndpoints.customeradmin.getcustomer)
  }, [getCustomer])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })

  const columns = [
    {
      accessorKey: "name",
      header: t("global.name", "Name")
    },
    {
      accessorKey: "organisationNumber",
      header: t("global.org_no", "Org. No.")
    },
    {
      accessorKey: "streetAddress",
      header: t("global.postal_address", "Postal Address")
    },
    {
      accessorKey: "postalCode",
      header: t("global.postal_code", "Postal Code")
    },
    {
      accessorKey: "cityAddress",
      header: t("global.city", "City"),
      cell: ({ cell }) => {
        return (
          <div component={Link} to={allRoutes.CustomerSettingsCompaniesEdit(cell.row.original.id)}>
            {cell.row.original.cityAddress}
          </div>
        )
      }
    },
    {
      accessorKey: "edit",
      header: "",
      meta: {
        align: "right"
      },
      cell: ({ cell }) => {
        return (
          <TableButton
            type={TableButtonTypeEnum.Edit}
            handleOnClick={() => {
              routerHistory.push(allRoutes.CustomerSettingsCompaniesEdit(cell.row.original.id))
            }}
          />
        )
      }
    }
  ]

  return (
    <div>
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
            <Typography variant="h1">{t("global.company", "Company")}</Typography>
            <Button color="primary" component={Link} to={allRoutes.CustomerSettingsCompaniesAdd()}>
              {t("settings.form.button.add_company", "Add company")}
            </Button>
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          onRowClick={(row) => routerHistory.push(allRoutes.CustomerSettingsCompaniesEdit(row.original.id))}
          rows={customerResult.status === 2 && customerResult.data.companies}
          loadingState={customerResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}
export default EditCustomerCompanies
